document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (drawer) {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  initProductPage();
  initHeaderSearch();
  initHeaderState();
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeDrawer();
  }
});

// --- GLOBAL CLICK DELEGATION ---
document.addEventListener('click', async (e) => {
  // 1. Sliding Menu Logic
  const menuGroup = document.querySelector('.header__menu-group');
  const slidingNav = document.querySelector('[data-mobile-menu]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  
  if (e.target.closest('[data-menu-toggle]')) {
    e.stopPropagation();
    if (slidingNav && menuToggle) {
      slidingNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', slidingNav.classList.contains('is-open'));
    }
  } else if (menuGroup && slidingNav && !menuGroup.contains(e.target)) {
    slidingNav.classList.remove('is-open');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
  }

  // 2. Cart Drawer Close
  if (e.target.closest('[data-cart-drawer-close]')) {
    closeDrawer();
  }

  // 3. Cart Quantity Change
  const qtyBtn = e.target.closest('[data-quantity-change]');
  if (qtyBtn) {
    e.preventDefault();
    await updateCartItem(
      qtyBtn.dataset.key,
      qtyBtn.dataset.quantity,
      { reloadPage: !qtyBtn.closest('[data-cart-drawer]') }
    );
  }

  // 4. Cart Item Remove
  const removeBtn = e.target.closest('[data-remove-item]');
  if (removeBtn) {
    e.preventDefault();
    await updateCartItem(
      removeBtn.dataset.key,
      0,
      { reloadPage: !removeBtn.closest('[data-cart-drawer]') }
    );
  }
});

// --- CORE CART FUNCTIONS ---

function openDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('cart-drawer-open');
}

function closeDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('cart-drawer-open');
}

async function refreshDrawer() {
  try {
    const [drawerResponse, cartResponse] = await Promise.all([
      fetch('/cart?view=drawer'),
      fetch('/cart.js', {
        headers: { Accept: 'application/json' }
      })
    ]);

    if (!drawerResponse.ok || !cartResponse.ok) {
      throw new Error('Unable to refresh cart');
    }

    const [text, cart] = await Promise.all([
      drawerResponse.text(),
      cartResponse.json()
    ]);
    
    const doc = new DOMParser().parseFromString(text, 'text/html');
    
    const newContent = doc.querySelector('[data-cart-drawer-body]');
    const currentDrawerBody = document.querySelector('[data-cart-drawer-body]');
    
    if (currentDrawerBody && newContent) {
      currentDrawerBody.innerHTML = newContent.innerHTML;
    }

    document.querySelectorAll('[data-cart-count]').forEach((count) => {
      count.textContent = `CART (${cart.item_count})`;
    });

    document.dispatchEvent(
      new CustomEvent('loar:cart-updated', { detail: { cart } })
    );

    return cart;
  } catch (error) {
    console.error('Drawer refresh error:', error);
    throw error;
  }
}

async function addToCart(variantId, quantity = 1) {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
  });
  if (!response.ok) throw new Error('Failed to add');
  return response.json();
}

async function updateCartItem(key, quantity, options = {}) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: Math.max(0, parseInt(quantity, 10) || 0)
      })
    });

    if (!response.ok) {
      throw new Error('Unable to update cart');
    }

    if (options.reloadPage) {
      window.location.reload();
      return;
    }

    await refreshDrawer();
    openDrawer();
  } catch (error) {
    console.error('Update error:', error);
  }
}

// --- INITIALIZATION ---

function initProductPage() {
  const productSection = document.querySelector('[data-product-id]');
  if (!productSection) return;

  // 1. Setup Elements
  const productJson = document.querySelector('[data-product-json]');
  const product = productJson ? JSON.parse(productJson.textContent) : null;
  
  const variantIdInput = document.querySelector('[data-variant-id]');
  const priceElement = document.querySelector('[data-product-price] span');
  const addToCartBtn = document.querySelector('[data-add-to-cart]');
  const mainImage = document.querySelector('[data-main-image]');
  const thumbnails = document.querySelectorAll('[data-thumbnail]');
  const optionButtons = document.querySelectorAll('[data-option-btn]');
  const quantityInput = document.querySelector('[data-quantity-input]');
  const btnMinus = document.querySelector('[data-quantity-minus]');
  const btnPlus = document.querySelector('[data-quantity-plus]');
  const addToCartLabel = addToCartBtn
    ? addToCartBtn.querySelector('[data-add-to-cart-text]') || addToCartBtn
    : null;

  // 2. Image Gallery Logic
  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbnails.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      if (mainImage) {
        mainImage.src = thumb.dataset.mediaSrc;
      }
    });
  });

  // 3. Quantity Selector Logic
  if (btnMinus && btnPlus && quantityInput) {
    btnMinus.addEventListener('click', () => {
      const current = parseInt(quantityInput.value) || 1;
      if (current > 1) quantityInput.value = current - 1;
    });
    btnPlus.addEventListener('click', () => {
      const current = parseInt(quantityInput.value) || 1;
      quantityInput.value = current + 1;
    });
  }

  // 4. Variant Selection (Size/Color) Logic
  let selectedOptions = {};
  if (product && product.options && product.variants) {
    product.options.forEach((option, index) => {
      selectedOptions[option] = product.variants[0][`option${index + 1}`];
    });
  }

  optionButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const optionName = btn.dataset.optionName;
      const optionValue = btn.dataset.optionValue;
      
      // Update UI: Highlight selected button
      document.querySelectorAll(`[data-option-name="${optionName}"]`).forEach(b => {
        b.classList.remove('is-selected');
      });
      btn.classList.add('is-selected');
      
      // Update UI: Text label
      const optionValueDisplay = document.querySelector(`[data-option-value="${optionName}"]`);
      if (optionValueDisplay) optionValueDisplay.textContent = optionValue;
      
      // Update internal data
      selectedOptions[optionName] = optionValue;
      updateVariant();
    });
  });

  function updateVariant() {
    if (!product) return;
    
    // Find the variant that matches all selected options
    const selectedVariant = product.variants.find(variant => {
      return product.options.every((option, index) => {
        return variant[`option${index + 1}`] === selectedOptions[option];
      });
    });

    if (selectedVariant) {
      // Update hidden input, price, and URL
      if (variantIdInput) variantIdInput.value = selectedVariant.id;
      if (priceElement) priceElement.textContent = formatMoney(selectedVariant.price);
      
      const url = new URL(window.location);
      url.searchParams.set('variant', selectedVariant.id);
      window.history.replaceState({}, '', url);
      
      // Update Add to Cart button state
      if (addToCartBtn) {
        if (selectedVariant.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'ADD TO CART';
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'SOLD OUT';
        }
      }
    }
  }

  // 5. Add To Cart AJAX Logic
  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = new FormData(productForm);
      const id = formData.get('id');
      const quantity = quantityInput ? parseInt(quantityInput.value) : 1;
      const defaultButtonText = addToCartLabel
        ? addToCartLabel.textContent.trim()
        : 'Add to bag';
      
      try {
        if (addToCartBtn) addToCartBtn.disabled = true;
        if (addToCartLabel) addToCartLabel.textContent = 'Adding...';
        await addToCart(id, quantity);
        await refreshDrawer();
        openDrawer();
        if (addToCartLabel) {
          addToCartLabel.textContent = 'Added';
          setTimeout(() => {
            addToCartLabel.textContent = defaultButtonText;
            if (addToCartBtn) addToCartBtn.disabled = false;
          }, 1600);
        }
      } catch (error) {
        alert('We could not add that item. Please try again.');
        if (addToCartLabel) addToCartLabel.textContent = defaultButtonText;
        if (addToCartBtn) addToCartBtn.disabled = false;
      }
    });
  }
}

function initHeaderSearch() {
  const form = document.querySelector('.header__search-form');
  const input = form ? form.querySelector('.header__search-input') : null;
  const button = form ? form.querySelector('.header__search-btn') : null;

  if (!form || !input || !button) return;

  button.addEventListener('click', (event) => {
    if (!input.value.trim() && document.activeElement !== input) {
      event.preventDefault();
      input.focus();
    }
  });
}

function initHeaderState() {
  const header = document.querySelector('.header');
  if (!header) return;

  const updateHeaderState = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 24);
  };

  updateHeaderState();
  window.addEventListener('scroll', updateHeaderState, { passive: true });
}